// makeTypedSetter.ts
import { ReportCode } from "../../../mc-shared/reportSchemas/reportSchemas";
import { Path, PathValue } from "../../../mc-shared/typedPath";
import { AppDispatch } from "../../../store";
import { setEditedValueInRedux } from "./reportSlice";

export const makeTypedSetter = <T, C extends ReportCode>(code: C) => {
  return <P extends Path<T>>(path: P, value: PathValue<T, P>) =>
    (dispatch: AppDispatch) => {
      dispatch(setEditedValueInRedux({ code, path, value }));
    };
};
